import type {ReactElement} from 'react';
import React from 'react';
import {ControlledList} from '@Components/controlled-list';
import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import {addTextSlideshowToPoster} from '@PosterWhiteboard/items/slideshow-item/slide-items/text-slide-item.class';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {AddItemThumbnail} from '@Components/poster-editor/components/poster-add-item-bar/components/add-item-thumbnail';
import {onOpenSlideshowStockMediaModal, onOpenSlideshowUserMediaModal} from '@Components/poster-editor/library/poster-editor-open-modals';
import type {AddItemDropdownProps} from '@Components/poster-editor/components/poster-add-item-bar/poster-add-item-bar.types';

export function SlideshowDropdownList({className = '', onOpenModal = (): void => {}}: AddItemDropdownProps): ReactElement<any> {
  const getSlideshowListOptions = (): ControlledListItemType[] => {
    return [
      {
        id: 'slideshow-options-text',
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
        text: window.i18next.t('pmwjs_add_text_slideshow'),
        subText: window.i18next.t('pmwjs_add_text_slideshow_description'),
        onClick: (): void => {
          addTextSlideshowToPoster();
        },
        thumbnail: {
          type: ThumbnailType.CUSTOM,
          content: <AddItemThumbnail icon="icon-text" />,
        },
      },
      {
        id: 'slideshow-options-upload',
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
        text: window.i18next.t('pmwjs_uploads'),
        subText: window.i18next.t('pmwjs_add_uploads_media_slide'),
        onClick: (): void => {
          onOpenModal();
          onOpenSlideshowUserMediaModal();
        },
        thumbnail: {
          type: ThumbnailType.CUSTOM,
          content: <AddItemThumbnail icon="icon-upload" />,
        },
      },
      {
        id: 'slideshow-options-media',
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_2,
        text: window.i18next.t('pmwjs_explore_media'),
        subText: window.i18next.t('pmwjs_add_stock_media_slide'),
        onClick: (): void => {
          onOpenModal();
          onOpenSlideshowStockMediaModal();
        },
        thumbnail: {
          type: ThumbnailType.CUSTOM,
          content: <AddItemThumbnail icon="icon-media" />,
        },
      },
    ];
  };
  return <ControlledList className={`spacing-m-0 ${className}`} items={getSlideshowListOptions()} />;
}
